import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { initPixel, trackStd, PIXEL_ID } from "../lib/pixel";

const ADMIN_PREFIX = "/admin";

// Standard events that belong to a PAGE VIEW (not to a click).
const PAGE_EVENTS = {
  "/danke-umzug": { name: "Lead", params: { content_name: "Umzug", value: 150, currency: "EUR" } },
  "/danke-entruempelung": { name: "Lead", params: { content_name: "Entruempelung", value: 150, currency: "EUR" } },
  "/angebot": { name: "ViewContent", params: { content_name: "Umzug Angebot" } },
  "/entruempelung": { name: "ViewContent", params: { content_name: "Entruempelung" } },
};

// Module-level guard: survives React re-renders / StrictMode double effects.
let lastPageEventPath = null;

/**
 * Pixel base code lives in /public/index.html (init + first PageView).
 * This component fires PageView on SPA route changes and the page-scoped
 * standard events (Lead / ViewContent) exactly once per page view.
 */
export default function PixelManager() {
  const { pathname } = useLocation();
  const firstRun = useRef(true);

  useEffect(() => {
    if (!PIXEL_ID) return;
    if (pathname.startsWith(ADMIN_PREFIX)) return;

    if (!window.__leukasTrack) {
      window.__leukasTrack = (name, params) => trackStd(name, params);
    }

    if (!window.fbq) {
      // Head script didn't run (e.g. landed on /admin first) -> init + PageView
      initPixel();
    } else if (!firstRun.current) {
      // Subsequent SPA route changes -> PageView (first one came from index.html)
      try { window.fbq("track", "PageView"); } catch (_) {}
    }
    firstRun.current = false;

    const evt = PAGE_EVENTS[pathname];
    if (evt && lastPageEventPath !== pathname) {
      lastPageEventPath = pathname;
      trackStd(evt.name, evt.params);
    }
  }, [pathname]);

  return null;
}
